/**
 * This is temporary default values that we will supply to CanvasBody in the Canvas App while we gradually
 * will wire in all real values for all props from the Designer App.
 */

import {ContentEditorState} from '@packages/shared/states';
import {defaultContentEditorViewportAdapter} from '@packages/systems/ContentEditorViewportAdapter';
import {
  type CanvasBodyProps,
  ProjectDataToStore,
} from '@packages/systems/designer/canvas';

/**
 * Default values for CanvasBody props that don't need to be replaced for Canvas App purposes
 */
type valuesThatWillNotBeReplacedType = Omit<
  CanvasBodyProps,
  | keyof ProjectDataToStore
  | 'dispatch'
  | 'previewMode'
  | 'isOpenCanvasActive'
  | 'customCodeExecutionAllowed'
  | 'assets'
  | 'classNameMap'
  | 'idAttrMap'
  | 'cssPropertyMap'
  | 'plugins'
  | 'bodyEventHandlers'
  | 'ix3ElementTargets'
  | 'ix2NodeMap'
  | 'loadedHeadScripts'
  | 'variantDataMap'
  | 'variables'
  | 'variableCollections'
  | 'stylesMap'
  | 'styleBlocks'
  | 'breakpoints'
  | 'apolloClient'
  | 'apolloCacheResetCounter'
  | 'dynamoData'
  | 'annotationsMode'
  | 'cmsCollectionListPreviewEnabled'
  | 'cmsCollectionListPreviewItemsCount'
  | 'cmsNestedCollectionListPreviewItemsCount'
  | 'componentLocalizations'
>;
const valuesThatWillNotBeReplaced: valuesThatWillNotBeReplacedType = {
  currentVariationId: null,
  contentEditorState: ContentEditorState(),
  contentEditorValidationError: null,
  editTargetNativeIdPath: null,
  editingGrid: false,
  focusedComponentType: ['__SitePlugin', 'page'],
  focusedSymbolNativeIdPath: [] as string[],
  forceCanvasBodyRerender: false,
  optimizationClickMode: false,
  saveCollectionItemField: () => {},
  selectedNativeIdPath: [],
  selectedNodeNativeId: null,
  canNavigateFromPageToCMS: false,
  dropTargets: [],
  isEphemeralChangeInProgress: false,
  showEmpty: false,
  showEmptyForBuildModeMap: {},
  pseudoMode: 'noPseudo',
  stopEditingText: () => {},
  editSiteMode: false,
  designSiteMode: false,
  affectedNodeIds: [], // looks like this is only needed to support presence outlines the presence in the Designer App
  buildMode: false,
  ix2SelectedActionListId: null,
  analyzeMode: false,
  codeComponentsSafeModeReason: undefined,
  contentEditorViewportAdapter: defaultContentEditorViewportAdapter,
  contentEditorFrameId: null,
};

export const defaultCanvasBodyProps: Omit<
  CanvasBodyProps,
  | 'dispatch'
  | 'previewMode'
  | 'isOpenCanvasActive'
  | 'customCodeExecutionAllowed'
  | keyof ProjectDataToStore
  | 'assets'
  | 'classNameMap'
  | 'idAttrMap'
  | 'cssPropertyMap'
  | 'plugins'
  | 'bodyEventHandlers'
  | 'ix3ElementTargets'
  | 'ix2NodeMap'
  | 'loadedHeadScripts'
  | 'variables'
  | 'variableCollections'
  | 'stylesMap'
  | 'styleBlocks'
  | 'breakpoints'
  | 'apolloClient'
  | 'apolloCacheResetCounter'
  | 'dynamoData'
  | 'annotationsMode'
  | 'cmsCollectionListPreviewEnabled'
  | 'cmsCollectionListPreviewItemsCount'
  | 'cmsNestedCollectionListPreviewItemsCount'
  | 'componentLocalizations'
> = {
  ...valuesThatWillNotBeReplaced,
};
